var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.06897 3.10346C2.06897 2.53213 2.53212 2.06896 3.10345 2.06896H8.62069C9.19202 2.06896 9.65517 1.60579 9.65517 1.0345C9.65517 0.463171 9.19202 1.00635e-06 8.62069 1.00635e-06H3.10345C1.38946 1.00635e-06 0 1.38947 0 3.10346V16.8965C0 18.6105 1.38946 20 3.10345 20H16.8966C18.6105 20 20 18.6105 20 16.8965V11.3793C20 10.808 19.5368 10.3448 18.9655 10.3448C18.3942 10.3448 17.931 10.808 17.931 11.3793V16.8965C17.931 17.4679 17.4679 17.931 16.8966 17.931H3.10345C2.53212 17.931 2.06897 17.4679 2.06897 16.8965V3.10346Z",
    fill: "url(#paint0_linear_1171_12368)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06264 11.3493C7.97183 11.4012 7.87049 11.4285 7.76756 11.4286C7.60154 11.4286 7.44358 11.3579 7.32619 11.232C7.2088 11.1061 7.14286 10.9355 7.14286 10.7574C7.14286 5.29894 10.5259 3.14955 13.9031 2.91731V0.670385C13.9033 0.539944 13.9388 0.412424 14.0055 0.303302C14.0722 0.194224 14.167 0.108338 14.2785 0.0561097C14.39 0.00392469 14.5132 -0.0123368 14.6332 0.00933067C14.7531 0.0310417 14.8646 0.0897227 14.9539 0.178224L19.7996 4.98304C19.8628 5.04586 19.9132 5.12203 19.9477 5.20669C19.9822 5.2914 20 5.38282 20 5.4752C20 5.56763 19.9822 5.65905 19.9477 5.74371C19.9132 5.82842 19.8628 5.90454 19.7996 5.96736L14.9539 10.77C14.8646 10.8585 14.7531 10.9172 14.6332 10.9389C14.5132 10.9605 14.39 10.9443 14.2785 10.8921C14.167 10.8398 14.0722 10.754 14.0055 10.6449C13.9388 10.5358 13.9033 10.4082 13.9031 10.2778V7.98972C12.9321 7.92751 11.9599 8.08799 11.0513 8.46039C9.56279 9.1078 8.30045 11.11 8.28835 11.1306C8.23097 11.2222 8.15346 11.2973 8.06264 11.3493Z",
    fill: "url(#paint1_linear_1171_12368)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1171_12368",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA6FFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#711CF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1171_12368",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA6FFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#711CF1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.da75f6bb50d2ae5bd9e0d01c62026d6b.svg";
export { ForwardRef as ReactComponent };